// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `app-header {
  position: relative;
}
app-header.bg::before,
app-header .bg::before {
  content: "";
  background: radial-gradient(116.99% 133.82% at 62.8% -21.64%, #0693c6 0%, #01688d 67.64%, #006184 100%);
  border-radius: 0px 0px 40px 40px;
  height: 275px;
  top: 0;
  left: 50%;
  transform: translate(-50%, 0);
  position: absolute;
  width: 100%;
}
app-header ion-back-button {
  color: #fff;
}
app-header ion-header {
  overflow: hidden;
  --background: transparent;
  margin-bottom: -1px !important;
}
app-header.fixed {
  position: absolute;
}
app-header ion-title {
  color: #fff;
  font-size: 20px;
  padding: 0 55px !important;
  position: absolute;
  line-height: inherit !important;
  left: 0;
  top: 50%;
  transform: translate(0, -50%);
  right: 0;
  font-weight: normal;
  margin-bottom: 0 !important;
  margin-top: 0 !important;
}
app-header ion-button {
  transition: none;
}
app-header ion-menu-button {
  --border-radius: 0;
}
app-header ion-menu-button svg {
  width: 22px !important;
  height: 38px !important;
  top: 3px;
  position: relative;
  left: 0;
}
app-header ion-menu-button .badge {
  width: 13px !important;
  height: 13px !important;
  border-radius: 50%;
  border: 2px solid #fff;
  position: absolute;
  z-index: 10;
  background: red;
  right: -2px;
  top: 8px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/header/header.component.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;AACF;AAAE;;EAEE,WAAA;EACA,uGAAA;EAOA,gCAAA;EACA,aAAA;EACA,MAAA;EACA,SAAA;EACA,6BAAA;EACA,kBAAA;EACA,WAAA;AAJJ;AAME;EACE,WAAA;AAJJ;AAME;EACE,gBAAA;EACA,yBAAA;EACA,8BAAA;AAJJ;AAME;EACE,kBAAA;AAJJ;AAME;EACE,WAAA;EACA,eAAA;EACA,0BAAA;EACA,kBAAA;EACA,+BAAA;EACA,OAAA;EACA,QAAA;EACA,6BAAA;EACA,QAAA;EACA,mBAAA;EACA,2BAAA;EACA,wBAAA;AAJJ;AAME;EACE,gBAAA;AAJJ;AAME;EACE,kBAAA;AAJJ;AAKI;EACE,sBAAA;EACA,uBAAA;EACA,QAAA;EACA,kBAAA;EACA,OAAA;AAHN;AAKI;EACE,sBAAA;EACA,uBAAA;EACA,kBAAA;EACA,sBAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;EACA,WAAA;EACA,QAAA;AAHN","sourcesContent":["app-header {\r\n  position: relative;\r\n  &.bg::before,\r\n  .bg::before {\r\n    content: \"\";\r\n    background: radial-gradient(\r\n        116.99% 133.82% at 62.8% -21.64%,\r\n        #0693c6 0%,\r\n        #01688d 67.64%,\r\n        #006184 100%\r\n      )\r\n      /* warning: gradient uses a rotation that is not supported by CSS and may not behave as expected */;\r\n    border-radius: 0px 0px 40px 40px;\r\n    height: 275px;\r\n    top: 0;\r\n    left: 50%;\r\n    transform: translate(-50%, 0);\r\n    position: absolute;\r\n    width: 100%;\r\n  }\r\n  ion-back-button {\r\n    color: #fff;\r\n  }\r\n  ion-header {\r\n    overflow: hidden;\r\n    --background: transparent;\r\n    margin-bottom: -1px !important;\r\n  }\r\n  &.fixed {\r\n    position: absolute;\r\n  }\r\n  ion-title {\r\n    color: #fff;\r\n    font-size: 20px;\r\n    padding: 0 55px !important;\r\n    position: absolute;\r\n    line-height: inherit !important;\r\n    left: 0;\r\n    top: 50%;\r\n    transform: translate(0, -50%);\r\n    right: 0;\r\n    font-weight: normal;\r\n    margin-bottom: 0 !important;\r\n    margin-top: 0 !important;\r\n  }\r\n  ion-button {\r\n    transition: none;\r\n  }\r\n  ion-menu-button {\r\n    --border-radius: 0;\r\n    svg {\r\n      width: 22px !important;\r\n      height: 38px !important;\r\n      top: 3px;\r\n      position: relative;\r\n      left: 0;\r\n    }\r\n    .badge {\r\n      width: 13px !important;\r\n      height: 13px !important;\r\n      border-radius: 50%;\r\n      border: 2px solid #fff;\r\n      position: absolute;\r\n      z-index: 10;\r\n      background: red;\r\n      right: -2px;\r\n      top: 8px;\r\n    }\r\n  }\r\n  // app-search {\r\n  //   ion-toolbar {\r\n  //     pointer-events: none;\r\n  //   }\r\n  // }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
